import { useGameStore } from '@/store/gameStore'
import { PageShell } from '../components/PageShell'
import { PageTabs } from '../components/PageTabs'
import { FeatureGate } from '../components/FeatureGate'
import { BroadcastHeader } from '../components/broadcast'
import { FEATURES } from '@/config/clubLevelConfig'
import { StaffTabContent } from '../panels/StaffTab'
import { AcademyTabContent } from '../panels/PlaceholderTabs'
import { RosterTabContent } from '../panels/RosterTab'
import { TransferMarketTabContent } from '../panels/TransferMarketTab'
import { ClubNeedsBanner } from '../components/ClubNeedsBanner'
import { Users, GraduationCap, UserCog, Medal, ArrowLeftRight } from 'lucide-react'

export function StaffPage() {
  const staff = useGameStore(s => s.staff)
  const totalSalary = staff.reduce((sum, s) => sum + s.salary, 0)
  return (
    <PageShell
      pageId="staff"
      title="Recursos Humanos"
      icon={<UserCog size={22} />}
    >
      <BroadcastHeader
        title="Plantilla del club"
        competition="Recursos humanos"
        icon={Users}
        meta={
          <>
            <span className="chip-angled tone-gold">{staff.length} en nómina</span>
            {totalSalary > 0 && <span className="chip-angled">-{totalSalary.toLocaleString('es-ES')}€/sem</span>}
          </>
        }
      />
      <ClubNeedsBanner />
      <PageTabs
        tabs={[
          {
            label: 'Empleados',
            icon: <Users size={16} />,
            content: <StaffTabContent />,
          },
          {
            label: 'Academia',
            icon: <GraduationCap size={16} />,
            content: <FeatureGate feature={FEATURES.ACADEMY}><AcademyTabContent /></FeatureGate>,
          },
          {
            label: 'Plantilla',
            icon: <Medal size={16} />,
            content: <FeatureGate feature={FEATURES.PLAYER_ROSTER}><RosterTabContent /></FeatureGate>,
          },
          {
            label: 'Mercado',
            icon: <ArrowLeftRight size={16} />,
            content: <FeatureGate feature={FEATURES.PLAYER_ROSTER}><TransferMarketTabContent /></FeatureGate>,
          },
        ]}
      />
    </PageShell>
  )
}
